import { Select, InputNumber, Button, Text } from '@clockout-dev/design-elements';
import { DeleteOutlined } from '@ant-design/icons';
import { RULE_TIMEFRAME_UNIT_OPTIONS, DEFAULT_RULE_TIMEFRAME } from '../availableBalanceForm.constants';
import styles from '../styles/availableBalanceForm.module.scss';

const CONDITION_PREFIX = {
    tenure: 'if a user has a tenure of',
    count: 'if a user has completed',
    employment: 'if a user has an employment type of',
    balance: 'if a user has an average daily balance of',
};

function BalanceRuleRow({ rule, conditionType, options = [], onUpdate, onRemove, disabled, showTimeframe = false }) {
    const prefixText = CONDITION_PREFIX[conditionType] || 'if a user has';
    const isLarge = ['count'].includes(conditionType);

    return (
        <div className={styles.ruleRow}>
            <Text as="span" size="s" className={styles.ruleLabel}>
                {prefixText}
            </Text>
            <Select
                size="large"
                value={rule.condition}
                options={options}
                onChange={(value) => onUpdate(rule.id, 'condition', value)}
                disabled={disabled || !options.length}
                popupMatchSelectWidth={isLarge ? false : true}
                className={`${styles.select} ${isLarge ? styles.selectFit : styles.selectMd}`}
            />
            {showTimeframe && (
                <>
                    <Text as="span" size="s" className={styles.ruleLabel}>
                        in the last
                    </Text>
                    <InputNumber
                        key={`timeframe-${rule.id}`}
                        defaultValue={rule.timeframeValue}
                        onChange={(value) => onUpdate(rule.id, 'timeframeValue', value)}
                        min={1}
                        max={365}
                        step={1}
                        precision={0}
                        controls={false}
                        disabled={disabled}
                        className={`${styles.inlineNumberInput} ${styles.countField}`}
                    />
                    <Select
                        size="large"
                        value={rule.timeframeUnit ?? DEFAULT_RULE_TIMEFRAME.timeframeUnit}
                        options={RULE_TIMEFRAME_UNIT_OPTIONS}
                        onChange={(value) => onUpdate(rule.id, 'timeframeUnit', value)}
                        disabled={disabled}
                        popupMatchSelectWidth={false}
                        className={`${styles.select} ${styles.selectSm}`}
                    />
                </>
            )}
            {isLarge ? <br /> : null}
            <Text as="span" size="s" className={styles.ruleLabel}>
                their available balance threshold will be exactly
            </Text>
            <InputNumber
                key={`value-${rule.id}`}
                defaultValue={rule.value}
                onChange={(value) => onUpdate(rule.id, 'value', value)}
                min={0}
                max={100}
                controls={false}
                disabled={disabled}
                suffix="%"
                className={`${styles.inlineNumberInput} ${styles.deductionField}`}
            />
            <Button
                type="button"
                size="s"
                variant="text"
                className={styles.deleteButton}
                onClick={() => onRemove(rule.id)}
                disabled={disabled}
            >
                <DeleteOutlined />
            </Button>
        </div>
    );
}

export default BalanceRuleRow;
